import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { take, tap } from 'rxjs';
import { JobDetailService } from '../../features/details/services/job-details.service';
import { SharedService } from '../../features/jobs/services/shared.service';
import { CookieService } from '../services/cookie/cookie.service';
import { Cookies } from '../../shared/enums/app.enums';

export function initProUser(): void {
  const jobDetailService = inject(JobDetailService);
  const sharedService = inject(SharedService);
  const cookieService = inject(CookieService);
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  if (!isBrowser) return;

  const cookieValue = decodeURIComponent(
    cookieService.getCookie(Cookies.MYBDJOBSGID) ?? ''
  );

  jobDetailService
    .getIsProUser(cookieValue)
    .pipe(
      take(1),
      tap((value) => sharedService.updateIsProState(value))
    )
    .subscribe();
}
